<template>
  <div class="editor">
    <b-modal 
          v-model="openSidebar"
          title="Editar Imagen" 
          header-bg-variant="secondary"
          header-text-variant="light"
          @hide="reset"
          :hide-footer="true"  
          :no-close-on-backdrop="true" 
          size="md"  
          >      
          <div
            class="canvas"
            @dblclick="dblclick"
            >
            <img
              ref="image"
              :alt="data.name"
              :src="data.url"
              @loadstart="start"
              @load="start"
            >
          </div>
          <div
            v-if="cropper"
            class="toolbar"
            @click="click"
            >
            <button
                class="toolbar__button"
                data-action="move"
                title="Mover (M)"
              >
              <b-icon icon="arrows-fullscreen"></b-icon>
            </button>
            <button
              class="toolbar__button"
              data-action="crop"
              title="Seleccionar (C)"
              >
              <b-icon icon="fullscreen"></b-icon>
            </button>
            <button
              class="toolbar__button"
              data-action="zoom-in"
              title="Zoom In (I)"
              >
              +
            </button>
            <button
              class="toolbar__button"
              data-action="zoom-out"
              title="Zoom Out (O)"
              >
              -
            </button>
            <button
              class="toolbar__button"
              data-action="rotate-left"
              title="Rotar Izquierda (L)"
              >
              <b-icon icon="arrow-counterclockwise"></b-icon>
            </button>
            <button
              class="toolbar__button"
              data-action="rotate-right"
              title="Rotar Derecha (R)"
              >
              <b-icon icon="arrow-clockwise"></b-icon>
            </button>
            <button
              class="toolbar__button"
              data-action="flip-horizontal"
              title="Flip Horizontal (H)"
              >
              <b-icon icon="arrow-left-right"></b-icon>
            </button>
            <button
              class="toolbar__button"
              data-action="flip-vertical"
              title="Flip Vertical (V)"
              >
              <b-icon icon="arrow-up-down"></b-icon>
            </button> 
            <button
              v-if="actions==='crop'"
              class="toolbar__button"
              data-action="cortar"
              title="Recortar (ENTER)"
              >
              <b-icon icon="crop"></b-icon>
            </button>
            <a        
              v-if="actions===null"
              @click="otroClick('save')"     
              class="toolbar__button"
              style="padding: 5px;"
              title="Guardar"
              >
              <b-icon icon="download"></b-icon>
            </a>
          </div>
          <div 
            v-else 
            class="toolbar guardar-tolbar"
            >     
            <div>
            </div> 
            <a
              @click="otroClick('restore')"
              class="toolbar__button" 
              style="padding: 5px;"
              title="Deshacer (CTRL + Z)"
              >
              <b-icon icon="arrow90deg-left"></b-icon>
            </a>
            <a        
              @click="otroClick('save')"     
              class="toolbar__button"
              style="padding: 5px;"
              title="Guardar"
              >
              <b-icon icon="download"></b-icon>
            </a>
          </div>    
    </b-modal>   
  </div>
</template>

<script>
import Cropper from 'cropperjs';
const URL = window.URL || window.webkitURL;

export default {
  name: 'Editor',

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    tabla: {
      type: String,
      default: ''
    },
    campo: {
      type: String,
      default: ''
    },
  },

  data() {
    return {
      openSidebar: true,
      canvasData:  null,
      cropBoxData: null,
      croppedData: null,
      cropper:     null,
      actions: null,
      close1: false,
      close2: false,
    };
  },
  mounted() {
    window.addEventListener('keydown', (this.onKeydown = this.keydown.bind(this)));
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onKeydown);
    this.stop();
  },
  methods: {
    click({ target }) {
      const { cropper } = this;
      const action = target.getAttribute('data-action') || target.parentElement.getAttribute('data-action');
      this.actions=action
      switch (action) {
        case 'move':
          cropper.setDragMode('move');
         break;           
        case 'cortar':
          this.crop();
          break;    
        case 'crop':
           cropper.setDragMode('crop');
          break;   
        case 'zoom-in':
          cropper.zoom(0.1);
          break;

        case 'zoom-out':
          cropper.zoom(-0.1);
          break;

        case 'rotate-left':
          cropper.rotate(-90);
          break;

        case 'rotate-right':
          cropper.rotate(90);
          break;

        case 'flip-horizontal':
          cropper.scaleX(-cropper.getData().scaleX || -1);
          break;

        case 'flip-vertical':
          cropper.scaleY(-cropper.getData().scaleY || -1);
          break;

        default:
      }
    },

    async otroClick(action) {
      const { cropper } = this;

      switch (action) {      
        case 'save':
          if(this.data.previousUrl!=='')
          {
            await this.updateDataForm({state: 'subir_archivos/'+this.data.index+'/base64', data: this.data.url })
          }          
          this.update({
              loaded: false,
              cropped: false,
            });
        break;

        case 'restore':
          this.actions='crop'
          this.restore();          
        break;

        default:
      }
    },

    keydown(e) {
      switch (e.key) {
        // Undo crop
        case 'z':
          if (e.ctrlKey) {
            e.preventDefault();
            this.restore();
          }

          break;

          // Delete the image
        case 'Delete':
          this.reset();
          break;

        default:
      }

      const { cropper } = this;

      if (!cropper) {
        return;
      }

      switch (e.key) {
        // Crop the image
        case 'Enter':
          this.crop();
          break;

          // Clear crop area
        case 'Escape':
          this.clear();
          break;
          

          // Move to the left
        case 'ArrowLeft':
          e.preventDefault();
          cropper.move(-1, 0);
          break;

          // Move to the top
        case 'ArrowUp':
          e.preventDefault();
          cropper.move(0, -1);
          break;

          // Move to the right
        case 'ArrowRight':
          e.preventDefault();
          cropper.move(1, 0);
          break;

          // Move to the bottom
        case 'ArrowDown':
          e.preventDefault();
          cropper.move(0, 1);
          break;

          // Enter crop mode
        case 'c':
          cropper.setDragMode('crop');
          break;

          // Enter move mode
        case 'm':
          cropper.setDragMode('move');
          break;

          // Zoom in
        case 'i':
          cropper.zoom(0.1);
          break;

          // Zoom out
        case 'o':
          cropper.zoom(-0.1);
          break;

          // Rotate left
        case 'l':
          cropper.rotate(-90);
          break;

          // Rotate right
        case 'r':
          cropper.rotate(90);
          break;

          // Flip horizontal
        case 'h':
          cropper.scaleX(-cropper.getData().scaleX || -1);
          break;

          // Flip vertical
        case 'v':
          cropper.scaleY(-cropper.getData().scaleY || -1);
          break;

        default:
      }
    },

    dblclick(e) {
      if (e.target.className.indexOf('cropper-face') >= 0) {
        e.preventDefault();
        e.stopPropagation();
        this.crop();
      }
    },

    start() {
      const { data } = this;

      if (data.cropped || this.cropper) {
        return;
      }

      this.cropper = new Cropper(this.$refs.image, {
        autoCrop: false,
        dragMode: 'move',
        background: false,
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'low',
        width: 1200,
        height: 1200,
        ready: () => {
          if (this.croppedData) {
            this.cropper
              .crop()
              .setData(this.croppedData)
              .setCanvasData(this.canvasData)
              .setCropBoxData(this.cropBoxData)


            this.croppedData = null;
            this.canvasData = null;
            this.cropBoxData = null;
          }
        },
        crop: ({ detail }) => {
          if (detail.width > 0 && detail.height > 0 && !data.cropping) {
            this.update({
              cropping: true,
            });
          }
        },
      });
    },

    stop() {
      if (this.cropper) {
        this.cropper.destroy();
        this.cropper = null;
      }
    },

    crop() {
      const { cropper, data } = this;

      if (data.cropping) {
        this.croppedData = cropper.getData();
        this.canvasData = cropper.getCanvasData();
        this.cropBoxData = cropper.getCropBoxData();
        this.update({
          cropped: true,
          cropping: false,
          previousUrl: data.url,
          url: cropper.getCroppedCanvas(data.type === 'image/png' ? {} : {
            fillColor: '#fff',
          }).toDataURL(data.type),
        });
        this.stop();
      }
    },

    clear() {      
      if (this.data.cropping) {
        this.cropper.clear();
        this.update({
          cropping: false,
          loaded: false,
        });
      }
    },

    restore() {
      if (this.data.cropped) {
        this.update({
          cropped: false,
          previousUrl: '',
          url: this.data.previousUrl,
        });
      }
    },

    reset() { 
      (this.data.index===0) ? this.close1=true : this.close2=true ; 
         
      this.stop();
      this.update({
        cropped: false,
        cropping: false,
        loaded: false,
        name: '',
        index: this.data.index,
        previousUrl: '',
        type: '',
        url: '',
        url2: '',
        close1: this.close1,
        close2: this.close2,
      });
    },

    update(data) {
      Object.assign(this.data, data);
    },
  },
};
</script>

<style>
.editor.modal-body {
  background: rgba(0,0,0,.1);
  padding-bottom: 40px !important;
}
.editor {
  height: 100%;
}
.guardar-tolbar{
  width: 4rem !important;
  right:0;
  left: 0;
  margin: auto;
  margin-left: -2rem !important;
}
.canvas {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
}
.canvas > img {
  max-height: 100%;
  max-width: 100%;
}


.toolbar {
  background-color: rgba(0, 0, 0, .5);
  bottom: 2px;
  color: #fff;
  height: 2rem;
  left: 50%;
  margin-left: -9rem;
  position: absolute;
  width: 18rem;
  z-index: 2015;
}

.toolbar__button {
  background-color: transparent;
  border-width: 0;
  color: #fff;
  cursor: pointer;
  display: block;
  float: left;
  font-size: .875rem;
  height: 2rem;
  text-align: center;
  width: 2rem;
}

.toolbar__button:focus {
  outline: none;
  }

.toolbar__button:hover {
  background-color: #0074d9;
  color: #fff;  
}
</style>
